export function cloneDeep<T> (value: T, seen = new WeakMap<object, unknown>()): T {
  if (value === null || typeof value !== 'object') {
    return value
  }
  const source = value as unknown as Record<PropertyKey, unknown>
  const cached = seen.get(source)
  if (cached !== undefined) {
    return cached as T
  }
  if (value instanceof Date) {
    return new Date(value.getTime()) as unknown as T
  }
  if (value instanceof RegExp) {
    return new RegExp(value.source, value.flags) as unknown as T
  }
  if (value instanceof Map) {
    const result = new Map<unknown, unknown>()
    seen.set(source, result)
    value.forEach((mapValue, mapKey) => {
      result.set(cloneDeep(mapKey, seen), cloneDeep(mapValue, seen))
    })
    return result as unknown as T
  }
  if (value instanceof Set) {
    const result = new Set<unknown>()
    seen.set(source, result)
    value.forEach((setValue) => result.add(cloneDeep(setValue, seen)))
    return result as unknown as T
  }
  if (Array.isArray(value)) {
    const result: unknown[] = []
    seen.set(source, result)
    value.forEach((item, index) => {
      result[index] = cloneDeep(item, seen)
    })
    return result as unknown as T
  }
  const result = Object.create(Object.getPrototypeOf(value)) as Record<PropertyKey, unknown>
  seen.set(source, result)
  Reflect.ownKeys(source).forEach((key) => {
    result[key] = cloneDeep(source[key], seen)
  })
  return result as unknown as T
}
